import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { homeRouteFor } from '../routes/homeRoute';
import { ROUTES } from '../routes/paths';

export function ForbiddenPage(): ReactNode {
  const { user } = useAuth();

  return (
    <div className="mx-auto mt-16 max-w-md rounded-card border border-line bg-surface p-8 text-center">
      <p className="text-3xl font-bold text-primary">403</p>
      <h1 className="mt-2 text-base font-semibold text-content">Sin permiso</h1>
      <p className="mt-1 text-sm text-muted">
        Tu cuenta no tiene acceso a esta seccion. Si crees que es un error, avisa al administrador.
      </p>
      <Link
        to={user ? homeRouteFor(user.role) : ROUTES.login}
        className="mt-5 inline-block rounded-card bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-hover"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
